export default "__VITE_ASSET__Dd9Nqksg__"